import { render, staticRenderFns } from "./SectionMobileApp.vue?vue&type=template&id=77e40d15&scoped=true"
import script from "./SectionMobileApp.vue?vue&type=script&lang=ts"
export * from "./SectionMobileApp.vue?vue&type=script&lang=ts"
import style0 from "./SectionMobileApp.vue?vue&type=style&index=0&id=77e40d15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e40d15",
  null
  
)

export default component.exports